import { Logger as ProjectLogger } from "@restaurant-store-logger";

interface LoggerInterface {
  new (
    name: string,
    level?: "LOG" | "DEBUG" | "INFO" | "WARN" | "ERROR" | "TABLE",
  ): LoggerInstance;
}

interface LoggerInstance {
  name: string;
  level: "LOG" | "DEBUG" | "INFO" | "WARN" | "ERROR" | "TABLE";
  disabled: boolean;
  log: (message?: unknown, ...optionalParams: unknown[]) => void;
  debug: (message?: unknown, ...optionalParams: unknown[]) => void;
  info: (message?: unknown, ...optionalParams: unknown[]) => void;
  warn: (message?: unknown, ...optionalParams: unknown[]) => void;
  error: (message?: unknown, ...optionalParams: unknown[]) => void;
  table: (message?: unknown, ...optionalParams: unknown[]) => void;
  getName(): string;
  disable(): LoggerInstance;
  enable(): LoggerInstance;
}

const Logger: LoggerInterface = ProjectLogger;

export { Logger };
